
export default {
  data() {
    return {
      searching: false,
      query: "",
      articles: [],
    };
  },
  watch: {
    async query(query) {
      if (!query) {
        this.articles = [];
        return;
      }

      this.searching = true;

      this.articles = await this.$content("articles")
        .only(["title", "slug"])
        .sortBy("createdAt", "asc")
        .limit(12)
        .search(query)
        .fetch();

      this.searching = false;
    },
  },
};
